import React, { Component, FC } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import PlaceholderSvg from 'inline-icons/placeholder.svg';
import { roundEdgeDevices } from '../../../constants';
import { imageBorderRadius } from '../../../themes';

const PlaceholderImageContainer = styled.div<any>`
  ${({ containerStyles }: any) => containerStyles}
`;

const Image = styled.img<any>`
  opacity: 0;
  transition: opacity 300ms;
  max-width: 100%;
  height: auto;

  ${({ styles }: any) => styles}

  // Using position absolute to keep the image from displacing
  // any other DOM elements when loading in
  ${({ loaded }: any) => (loaded ? 'opacity: 1;' : 'position: absolute;')}
  ${({ isSquircle, borderRadius }: any) => {
    if (isSquircle) {
      return `mask: url(/device-images/squircle.png) 50% 0% / 100% no-repeat; -webkit-mask: url(/device-images/squircle.png) 50% 0% / 100% no-repeat;`;
    } else {
      return `border-radius: ${borderRadius != null ? borderRadius : imageBorderRadius};`;
    }
  }}
`;

// Using an svg to placehold for the image while loading
const Svg = styled.svg<any>`
  max-width: 100%;
  height: auto;
  fill: #e2e2e2;

  ${({ hide }: any) => (hide ? 'display: none;' : '')}
`;

const Placeholder = styled.div.attrs<any, any>({
  dangerouslySetInnerHTML: {
    __html: PlaceholderSvg
  }
})`
  ${({ hide }: any) => (hide ? 'display: none;' : '')}
`;

interface SvgOrIconPlaceholderProps {
  showIconPlaceholder: boolean;
  hide: boolean;
  width: any;
  height: any;
}

const SvgOrIconPlaceholder: FC<SvgOrIconPlaceholderProps> = ({ showIconPlaceholder, hide, ...props }) =>
  showIconPlaceholder ? (
    <Placeholder hide={hide} />
  ) : (
    <Svg hide={hide} {...props} />
  );

interface ImageContainerProps {
  containerAttr: {
    iconPlaceholder: boolean;
    styles: any;
    width?: any;
    height?: any;
  };
  imageAttr: {
    alt: string;
    src: string;
    styles: any;
  };
  isSquircle?: boolean;
  currentUser: any;
  className?: string;
  id?: string;
  onClick?: () => void;
  borderRadius: string;
}

class ImageContainer extends Component<ImageContainerProps> {

  state = {
    loaded: false
  };

  handleImageLoaded = () => {
    this.setState({
      loaded: true
    });
  };

  get device() {
    const { currentUser: { device = {} } = {} } = this.props;

    return device;
  }

  get deviceName() {
    return (this.device.productName || '').toLowerCase();
  }

  get isSquircle() {
    return roundEdgeDevices.includes(this.deviceName);
  }

  render() {
    const {
      children,
      className,
      containerAttr,
      imageAttr,
      borderRadius,
      ...props
    } = this.props;
    const {
      width,
      height,
      styles: containerStyles,
      iconPlaceholder,
      ...containerProps
    } = containerAttr;
    const { loaded } = this.state;

    return (
      <PlaceholderImageContainer
        containerStyles={containerStyles}
        className={className}
        imageLoaded={loaded}
        {...containerProps}
        {...props}
      >
        <SvgOrIconPlaceholder
          showIconPlaceholder={iconPlaceholder}
          width={width}
          height={height}
          hide={loaded}
        >
          <rect width="100%" height="100%" />
        </SvgOrIconPlaceholder>
        <Image
          onLoad={this.handleImageLoaded}
          loaded={loaded}
          {...imageAttr}
          isSquircle={this.isSquircle}
          borderRadius={borderRadius}
        />
        {children}
      </PlaceholderImageContainer>
    );
  }
}

const mapStateToProps = (state: any) => ({
  currentUser: state.registry.currentUser,
});

export default connect(mapStateToProps)(ImageContainer);
